$(function () {

    //下载切换
    $('.tab-t .tab-t-item').on("click", function (e) {
        $(this).addClass("active").siblings().removeClass('active');

        $(this).parent(".tab-t").parent(".r-info-b").find(".bigitem").eq($(this).index()).addClass("active").siblings().removeClass("active");

    });

    //评论的问题回答切换
    $('.comment-list .tab-t  .tab-t-item').on("click", function (e) {
        $(this).addClass("active").siblings().removeClass('active');

        // $(this).parent(".tab-t").parent(".comment-list").find(".bigitem").eq($(this).index()).addClass("active").siblings().removeClass("active");
        $(this).parent(".tab-t").siblings().find(".bigitem").eq($(this).index()).addClass("active").siblings().removeClass("active");


    });

    //内页导航固定
    // $('.postop').$scrollH('.postop', "postnow", 1, 0, "collapsed");

    //内页子导航下拉

    $('.nypos .box').on("click", function (e) {
        var is_on = $(this).is('.active');
        if (is_on) {
            $(this).removeClass('active');
            $(this).children('ul').slideUp();
        } else {
            $(this).addClass('active');
            $(this).children('ul').slideDown();
        }

        $(document).on("click", function (e) {
            var target = $(e.target);
            if (target.closest(".nypos .box").length == 0) {
                $('.nypos .box').removeClass('active');
                $('.nypos .box ul').slideUp();
            }
            e.stopPropagation();
        })
    });


    //产品详情遮罩层播放视频
    $('.productDetail').$video_play('.productDetail', ".videobox");
    //shopify遮罩层播放视频
    $('.buynow').$video_play('body', ".videobox");

    //视频列表点击遮罩层播放视频
    $('.videoList').$video_play('.videoList', ".videobox");

    $('.videoend').on('play', function (e) {
        setTimeout(() => {
            $('.videoendAdd').addClass('active  bounceInUp')
            $('#detailEilik3')[0].play()
        }, 300)
    });

    // 产品详情底部视频 和按钮点击后弹窗播放视频
    // $('.videoBtn').$video_play('.top-c-box',".videoBtn");

    // buynow页 问题列表展开收起
    $('.question-list-item').on("click", function (e) {
        var has = $(this).hasClass("active");
        if (has) {
            $(this).removeClass('active');
            $(this).children('.question-hide').slideUp();
        } else {

            $(this).siblings('.question-list-item').removeClass('active').children('.question-hide').slideUp();
            $(this).addClass('active').children('.question-hide').slideDown();

        }
    })

    // buynow 页面点击显示下拉选择项通用
    $('.form-select,.comment-screen').on("click", function (e) {
        return
        var this_tagName = $(this)[0].className;
        var has = $(this).hasClass("active");
        if (has) {
            $(this).removeClass('active');
            $(this).children('.downselect').slideUp();
        } else {
            // $(this).siblings('.question-list-item').removeClass('active').children('.question-hide').slideUp();
            $(this).addClass('active').children('.downselect').slideDown();
        }

        $(document).on("click", function (e) {
            var target = $(e.target);
            if (target.closest(`.${this_tagName}`).length == 0) {

                $(`.${this_tagName}`).removeClass('active');
                $(`.${this_tagName}`).children('.downselect').slideUp();
            }

        })
    })
    // $('.loadone-parent').each(function (i, ele) {
    //     // console.log($('.loadone-parent'),'333')
    //     $(this).find('.loadone').eq(0).addClass('active');
    //     $(this).find('.loadone-bro').eq(0).addClass('active');
    //     // console.log($(this).find('.loadone'),'44')
    // })
    // 点击添加类名 其他去除类名
    $('.addClass').on("click", function (e) {

        var has = $(this).hasClass("active");
        var carflag = $(this).parent().hasClass("downselect-up");
        var pageflag = $(this).parent().hasClass("downselect");
        var p = $('.downselect-text');
        var s = $(this).text();
        // debugger
        if (has) {
            // $(this).removeClass('active');
            // p.text('')
            // $(this).children('.downselect').slideUp();
        } else {
            $(this).addClass('active').siblings().removeClass('active');
            if (carflag) {
                $('.downselect .downselect-item').eq($(this).index()).addClass('active').siblings().removeClass('active')
            }
            if (pageflag) {
                $('.downselect-up .downselect-item').eq($(this).index()).addClass('active').siblings().removeClass('active')
            }
            // debugger
            // p.text(s)
        }
        // $(this).toggleClass('active')
    })



    // 技术支持 三级分类联动
    $(".cate1-t,.cate2-t").on("click", function () {
        var this_tagName = $(this)[0].className;
        var has = $(this).hasClass("active");
        if (has) {
            $(this).removeClass('active').siblings().slideUp();
        } else {
            $(this).addClass('active').siblings().slideDown();
        }
    });


    // 技术支持导航栏
    $('#click1,#click2,.supportmask').on("click", function (e) {
        // var has = $('#click1').hasClass("active");

        $('#click1,#click2,.supportmask,.supportDetail-l').toggleClass('active')
        // if(has) {
        //     $('#click1').removeClass('active').siblings('.supportmask').removeClass('active');
        //     $('.supportDetail-l').removeClass('active');
        // } else {
        //      $('#click1').addClass('active').siblings('.supportmask').addClass('active');
        //      $('.supportDetail-l').addClass('active');
        // }

    })

    // 加减函数
    $('.iless,.iadd').on({
        "click": function (e) {
            var isadd = $(this).hasClass("iadd");
            // var num = parseInt($(this).siblings('.ibox').children('.inputbox').val());
            var num = parseInt($('.inputbox').val());
            if (isadd) {
                num += 1;
            } else {
                if (num == 1 || num == 0) return;
                num -= 1;
            }
            // $(this).addClass('active');
            // $('#inputbox').val(num)
            // $(this).siblings('.ibox').children('.inputbox').val(num)
            $('.inputbox').val(num)
        },
        "mouseover mouseout": function (e) {
            $(this).toggleClass('active');
        }
    })

    //点击下载
    $('.down_name').on("click", function (e) {
        var down_name = $(this).attr("down-name");
        var down_url = $(this).attr("down-url");

        // if(!down_url) return false
        if (down_url) {
            var file = down_url.split(".");
            for (var i = 0; i < file.length; i++) {
                if (i == 1) {
                    $(this).attr("download", down_name + '.' + file[i]);

                }
            }
        }

    });

    //点击显示全部软固件
    $(".bigitem .tips1").on("click", function () {
        $(this).parent(".bigitem").find(".tab-c-list-item").removeClass("hide");
        $(this).addClass("hide");
        $(this).parent(".bigitem").find(".tab-tips.tips2").removeClass("hide");
    });
    //点击隐藏全部软固件
    $(".bigitem .tips2").on("click", function () {
        $(this).parent(".bigitem").find(".tab-c-list-item").addClass("hide");
        $(this).parent(".bigitem").find(".tab-c-list-item:nth-child(1)").removeClass("hide");
        $(this).addClass("hide");
        $(this).parent(".bigitem").find(".tab-tips.tips1").removeClass("hide");
    });





});